import { Typography, Link, Grid, Stack, Box } from '@mui/material';
import { permissions } from 'constants/permissions';
import useCheckPermission from 'hooks/useCheckPermission';
import AccessRequestForm from 'pages/Projects/AccessRequestForm';
import ProjectCreationForm from 'pages/Projects/ProjectCreationForm';
import { IS_EFP, EUROHPC_CALLS_URL, EFP_ALLOCATIONS_URL } from 'config';

const commonGridStyles = {
    minHeight: '70vh',
    pt: '1.5rem',
    pb: '1rem',
    overflow: 'hidden',
};

const linkStyles = {
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer',
    fontWeight: 'bold',
};

const Welcome = () => {
    const checkPerms = useCheckPermission();

    const renderEfpContent = () => (
        <Stack direction='column' spacing={3}>
            <Box textAlign='center'>
                <Typography variant='h2' marginBottom={3}>
                    Welcome to the EFP Workflows
                </Typography>
                <Typography variant='h3' marginBottom={4}>
                    You are not a member of any project
                </Typography>
                <Typography variant='body1' sx={{ fontSize: '1.1rem', maxWidth: '600px', mx: 'auto' }}>
                    Please refer to{' '}
                    <Link
                        href={EFP_ALLOCATIONS_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        underline='hover'
                        sx={linkStyles}>
                        EFP Allocations
                    </Link>{' '}
                    and{' '}
                    <Link
                        href={EUROHPC_CALLS_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        underline='hover'
                        sx={linkStyles}>
                        EuroHPC calls (EuroHPC JU web)
                    </Link>
                </Typography>
            </Box>
        </Stack>
    );

    const renderDefaultContent = () => (
        <Stack direction='column'>
            <Box marginBottom={5} textAlign='center'>
                <Typography variant='h2' marginBottom={5}>
                    Welcome to the LEXIS Platform
                </Typography>
                <Typography variant='h3'>You are not assigned to any project</Typography>
            </Box>
            <Box marginBottom={5} textAlign='center'>
                <Typography variant='h4' color='lightskyblue' marginBottom={5}>
                    Try to ask for project access
                </Typography>
                <AccessRequestForm disabled={!checkPerms(permissions.usrRequest, '')} />
            </Box>
            <Box textAlign='center'>
                <Typography variant='h4' color='success.main' marginBottom={5}>
                    Or create a new project
                </Typography>
                <ProjectCreationForm disabled={!checkPerms(permissions.prjCreate, '')} />
            </Box>
        </Stack>
    );

    return (
        <Grid
            container
            direction='column'
            alignItems='center'
            justifyContent='center'
            alignContent='center'
            textAlign='center'
            sx={commonGridStyles}>
            {IS_EFP ? renderEfpContent() : renderDefaultContent()}
        </Grid>
    );
};

export default Welcome;
